let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("rlx05")).then(() => parcelRequire('arSLF'));